import { useConnect } from '@lore/query-connect';
import { project_networkId } from '../../../../utils/query-helpers';

export default function useEducatorProjectEvaluationsCreated(network, timestamp) {
  return useConnect('evaluationProjectEducator.find', {
    where: {
      eager: {
        $where: {
          ...project_networkId(network),
          createdAt: {
            $gte: timestamp.start,
            $lte: timestamp.end
          }
        }
      },
    },
    pagination: {
      pageSize: 1
    }
  });
}
